import React, { useState } from 'react';
import OutlinedEllipsisSquare from 'acud-icon/lib/icons/OutlinedEllipsisSquare';
import Popover from '../popover';
export default (props) => {
    const { prefixCls, popoverContent, popoverZIndex } = props;
    const [popVisible, setPopVisible] = useState(false);
    const handleVisibleChange = (visible) => {
        setPopVisible(visible);
    };
    return (<Popover trigger="click" placement="rightBottom" zIndex={popoverZIndex === undefined ? 1051 : popoverZIndex} visible={popVisible} content={(<ul className={`${prefixCls}-popover-util`} onClick={() => setPopVisible(false)}>
                    {popoverContent}
                </ul>)} onVisibleChange={handleVisibleChange}>
            <OutlinedEllipsisSquare />
        </Popover>);
};
